import { render, staticRenderFns } from "./VideoSlidePanel.vue?vue&type=template&id=1fc06f23&"
import script from "./VideoSlidePanel.vue?vue&type=script&lang=js&"
export * from "./VideoSlidePanel.vue?vue&type=script&lang=js&"
import style0 from "./VideoSlidePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VNavigationDrawer,VRow})
